import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Ornament } from './Ornament';
import { checkoutUrl, offer, offerCta, offerItems } from '../data/content';
export function OfferStack() {
  return <section id="oferta" className="scroll-mt-4 bg-rose-wash text-ink" data-id="element-155" data-mp="2pumx1wch15to">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-6 lg:py-24" data-id="element-156" data-mp="2kvtpslns2b1y">
        <div className="mx-auto max-w-lg rounded-[32px] bg-white px-6 py-10 text-center shadow-[0_30px_60px_-30px_rgba(104,69,54,0.45)] ring-1 ring-gold/30 sm:px-10" data-id="element-157" data-mp="1x67u486m6dyp">
          <p className="font-sans text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-gold-deep" data-id="element-158" data-mp="1t2t3knl1uf70">
            Lo que recibes
          </p>
          <h2 className="mt-2 font-display text-[1.9rem] font-semibold leading-tight text-brown sm:text-4xl" data-id="element-159" data-mp="225c24vhsy5ng">
            Tu desafío completo
          </h2>

          <ul className="mt-7 space-y-3 text-left" data-id="element-160" data-mp="1edn4czm7ooz4">
            {offerItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-161" data-mp="19gmyopt9xo8j">
                <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-rose-wash" data-id="element-162" data-mp="14pv7n5dffh9q">
                  <CheckIcon className="h-3.5 w-3.5 text-rose-deep" strokeWidth={3} aria-hidden="true" data-id="element-163" data-mp="19mvc5bumobyq" />
                </span>
                <span className="font-sans text-[0.98rem] font-medium leading-snug text-ink" data-id="element-164" data-mp="1egzl20ngeu2g">{item}</span>
              </li>)}
          </ul>

          <Ornament className="mt-9" data-id="element-165" data-mp="lqqzdytplrj4" />

          <p className="mt-6 font-sans text-xs font-semibold uppercase tracking-[0.24em] text-ink-soft" data-id="element-166" data-mp="lrseqfhrd06n">
            Todo el material
          </p>
          <p className="mt-1 font-display text-lg italic text-ink-soft" data-id="element-167" data-mp="vona4piqikgp">por solo</p>
          <p className="font-display text-[3.6rem] font-bold leading-none text-rose-deep sm:text-7xl" data-id="element-168" data-mp="zq0hj41h6vpq">
            {offer.price}
          </p>
          <p className="mt-2 font-sans text-xs font-bold uppercase tracking-[0.24em] text-brown" data-id="element-169" data-mp="272irm4x435b3">
            {offer.note}
          </p>

          <div className="mt-8" data-id="element-170" data-mp="2b78krm0dy5sb">
            <CtaButton href={checkoutUrl} data-id="element-171" data-mp="c05n6kyiv29t">{offerCta}</CtaButton>
          </div>
          <p className="mt-3 font-sans text-xs text-ink-soft" data-id="element-172" data-mp="c28h3g2spfjt">Acceso digital después de la compra.</p>
        </div>
      </div>
    </section>;
}